<template>
  <div class="content">
    <!-- 树形和搜索 -->
    <SchemaTree   class="tree" ref="SchemaTree" @changeNode="changeNode"> </SchemaTree>
  </div>
</template>

<script>
import bus from '@/utils/bus.js'
import SchemaTree from './SchemaTree.vue'

export default {
  components: {
    SchemaTree
  },
  data () {
    return {
      checkTree: null
    }
  },
  mounted () {
    // 监听地图标记点击事件，选中对应树节点
    bus.$on('selectMapTreeNode', ({ type, nodeId }) => {
      if (this.$refs.SchemaTree) {
        this.$refs.SchemaTree.selectNodeById(type, nodeId)
      }
    })
  },
  beforeDestroy () {
    bus.$off('selectMapTreeNode')
  },
  methods: {
    changeNode (label) {
      this.checkTree = label
      bus.$emit('checkTree', label)
      // 发送事件让地图设置对应标记的选中状态
      bus.$emit('treeNodeSelected', label)
    },

  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 300px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;

  .tree {
    height: auto;
    flex: 1;
    width: 100%;
  }

  .tabs {
    padding-right: 5px;
    box-sizing: border-box;
  }

  .el-button {
    position: absolute;
    left: 5px;
    right: 5px;
    bottom: 10px;
  }
}
</style>
